import { useCallback } from 'react';
import { PusherEventName } from 'anchor-scout-common/types/pusher';
import { routes } from '~/constants';
import { useIoContext, useStoreActions } from '~/contexts';
import { usePusherBusinessChannel } from '~/pusher';
const INVOICE_ISSUED_TIMEOUT_MS = 30000;
export function useAdHocApprovalLink() {
    const { getChannel } = usePusherBusinessChannel();
    const { api } = useStoreActions();
    const { browser: { getOrigin } } = useIoContext();
    const startListening = useCallback((relationshipId)=>{
        return new Promise((resolve, reject)=>{
            const channel = getChannel('scout');
            if (!channel) {
                reject(new Error('Pusher scout channel not available'));
                return;
            }
            const handler = (payload)=>{
                if (payload.relationshipId !== relationshipId) return;
                clearTimeout(timeout);
                channel.unbind(PusherEventName.AdHocInvoiceIssued, handler);
                resolve(payload.invoiceId);
            };
            const timeout = setTimeout(()=>{
                channel.unbind(PusherEventName.AdHocInvoiceIssued, handler);
                reject(new Error('Timed out waiting for invoice'));
            }, INVOICE_ISSUED_TIMEOUT_MS);
            channel.bind(PusherEventName.AdHocInvoiceIssued, handler);
        });
    }, [
        getChannel
    ]);
    const resolveApprovalLink = useCallback(async (invoiceIdPromise)=>{
        const invoiceId = await invoiceIdPromise;
        const { notificationId } = await api.invoice.adhocApprovalLink(invoiceId);
        return "".concat(getOrigin()).concat(routes.notification(notificationId));
    }, [
        api,
        getOrigin
    ]);
    return {
        startListening,
        resolveApprovalLink
    };
}
